<div class="portal-app">
    <dds-header [name]="headerOptions.name" [theme]="headerOptions.theme" [width]="headerOptions.width"
        [isInverse]="headerOptions.isInverse" [isResponsive]="true" [responsivePriority]="responsivePriority">

        <ng-container logo>
            @switch (headerOptions.theme) {
            @case ('custom') {
            <img [src]="customLogoPath" alt="Logo">
            }
            @default {
            <dds-logo></dds-logo>
            }
            }
        </ng-container>

        <ng-container navigation>
            @for (route of routes; track route) {
            <dds-button [theme]="rla.isActive ? headerOptions.theme : buttonOptions.theme"
                [isInverse]="rla.isActive ? activeBtnNavState : headerOptions.isInverse" [routerLink]="route.path"
                [routerLinkActiveOptions]="{exact: true}" routerLinkActive tabindex="-1" #rla="routerLinkActive"
                role="menuitem">
                {{route.title}}
            </dds-button>
            }
        </ng-container>

        <ng-container profile>
            <dds-profile [username]="profileOptions.username" [nameLetter]="profileOptions.nameLetter"
                [userInfo]="profileOptions.userInfo" [photoUrl]="profileOptions.photoUrl" [stickerIndent]="5">
                <dds-profile-item>
                    Log out
                </dds-profile-item>
            </dds-profile>
        </ng-container>

        <ng-container mobileNavList>
            <dds-context-menu size="lg">
                <dds-context-menu-item>
                    <span class="dds-icon_sm dds-icon_download"></span> Archive
                </dds-context-menu-item>
                <dds-context-menu-item>
                    <span class="dds-icon_sm dds-icon_bookmark"></span> Bookmarks
                </dds-context-menu-item>
                <dds-context-menu-item>
                    <span class="dds-icon_sm dds-icon_calendar"></span> Calendar
                </dds-context-menu-item>
                <dds-context-menu-item>
                    <span class="dds-icon_sm dds-icon_external-link"></span> External navigation
                </dds-context-menu-item>
            </dds-context-menu>
        </ng-container>
    </dds-header>
    <hr class="inverse-header-separator" [ngStyle]="{
          'background-color': contentSeparatorColor
      }">
    <router-outlet></router-outlet>

    <dds-footer [isInverse]="footerOptions.isInverse" [ariaLabel]="footerOptions.ariaLabel" [role]="footerOptions.role"
        [customClass]="footerOptions.customClass">
        <div content maxWidth="600px">
            <strong class="dds-footer__title">
                For questions, concerns, or feedback, please contact
                <a href="mailto:admin@deloitte.com" ddsFocus class="dds-link dds-link_dark"
                    target="_blank">Admin&#64;deloitte.com</a>
            </strong>
            <p class="dds-footer__text">
                Deloitte refers to one or more of Deloitte Touche Tohmatsu Limited (“DTTL”), its global network of
                member
                firms, and their related entities (collectively, the “Deloitte organization”). DTTL (also referred to as
                “Deloitte Global”) and each of its member firms and related entities are legally separate and
                independent
                entities, which cannot obligate or bind each other in respect of third parties. DTTL and each DTTL
                member firm
                and related entity is liable only for its own acts and omissions, and not those of each other. DTTL does
                not
                provide services to clients.
                <br>
                Please see
                <a href="www.deloitte.com/about" ddsFocus class="dds-link dds-link_inverse"
                    target="_blank">www.deloitte.com/about</a>
                to learn more.
            </p>
            <p class="dds-footer__text">
                © 2022 For information, contact Deloitte Global.
            </p>
        </div>
    </dds-footer>
</div>